import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type ProjectStatus = 'green' | 'orange' | 'red'
export type BadgeVariant = 'default' | 'destructive' | 'outline' | 'secondary' | null

export function getProjectStatusConfig(status: ProjectStatus) {
  switch (status) {
    case 'green':
      return {
        label: 'On Track',
        color: 'bg-green-600',
        lightColor: 'bg-green-100',
        hoverColor: 'hover:bg-green-700',
        textColor: 'text-white',
        variant: 'default' as BadgeVariant
      }
    case 'orange':
      return {
        label: 'At Risk',
        color: 'bg-orange-500',
        lightColor: 'bg-orange-100',
        hoverColor: 'hover:bg-orange-600',
        textColor: 'text-white',
        variant: 'secondary' as BadgeVariant
      }
    case 'red':
      return {
        label: 'Blocked',
        color: 'bg-red-600',
        lightColor: 'bg-red-100',
        hoverColor: 'hover:bg-red-700',
        textColor: 'text-white',
        variant: 'destructive' as BadgeVariant
      }
    default:
      return {
        label: 'Unknown',
        color: 'bg-gray-500',
        lightColor: 'bg-gray-100',
        hoverColor: 'hover:bg-gray-600',
        textColor: 'text-white',
        variant: 'outline' as BadgeVariant
      }
  }
}
